module.exports = __webpack_public_path__ + "img/electronic_electric_use.f55cd967.svg";